import { AgmCoreModule } from '@agm/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgbDropdownModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import * as echarts from 'echarts';
import { NgxEchartsModule } from 'ngx-echarts';
import { SearchModule } from '../global/search/search.module';
import { CampaignManagementComponent } from './campaign-management.component';
import { InputNumericModule } from './components/input-numeric/input-numeric.module';
import { CampaignIndexModule } from './modules/campaign-index/campaign-index.module';
import { PendingApprovalDialogViewComponent } from './modules/campaign-index/dialog/pending-approval-dialog-view';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { NewCampaignComponent } from './modules/new-campaign';
import { GeneralInformationEmailComponent } from './modules/new-campaign/components/general-information-email';
import { GeneralInformationLineComponent } from './modules/new-campaign/components/general-information-line';
import { GeneralInformationSMSComponent } from './modules/new-campaign/components/general-information-sms';
import { GeneralInformationWAComponent } from './modules/new-campaign/components/general-information-wa';
import { FailoverMechanismComponent } from './modules/new-campaign/failover-mechanism';
import { GeneralInformationComponent } from './modules/new-campaign/general-information';
import { NewNumberBasesComponent } from './modules/new-campaign/new-number-bases';
import { SchedulerComponent } from './modules/new-campaign/scheduler';
import { SummaryComponent } from './modules/new-campaign/summary';
import { WizardComponent } from './modules/wizard';
import { VideoPosterPipe } from './util/video-poster.pipe';
import { WaMediaPreviewComponent } from './modules/new-campaign/components/wa-media-preview';

@NgModule({
    declarations: [
        CampaignManagementComponent,
        WizardComponent,
        NewCampaignComponent,
        GeneralInformationComponent,
        SchedulerComponent,
        SummaryComponent,
        NewNumberBasesComponent,
        GeneralInformationLineComponent,
        GeneralInformationWAComponent,
        GeneralInformationSMSComponent,
        GeneralInformationEmailComponent,
        PendingApprovalDialogViewComponent,
        FailoverMechanismComponent,
        VideoPosterPipe,
        WaMediaPreviewComponent,
    ],
    imports: [
        CommonModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyCHReBe_RpzAgLTrUC5QIDyeKttQ817wRY',
            libraries: ['places'],
        }),
        DashboardModule,
        MatAutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatRadioModule,
        MatListModule,
        MatButtonModule,
        NgxEchartsModule.forRoot({
            echarts,
        }),
        MatIconModule,
        PickerModule,
        AngularEditorModule,
        MatDialogModule,
        MatTabsModule,
        MatBadgeModule,
        NgbDropdownModule,
        NgbPaginationModule,
        MatCardModule,
        MatTableModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatGridListModule,
        MatDatepickerModule,
        MatSortModule,
        SearchModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        DragDropModule,
        CampaignIndexModule,
        InputNumericModule,
    ],
    exports: [
        CampaignManagementComponent,
        SummaryComponent,
        VideoPosterPipe,
        WaMediaPreviewComponent,
    ],
    entryComponents: [PendingApprovalDialogViewComponent],
    providers: [DatePipe],
})
export class CampaignManagementModule {}
